<script setup>
import { Link } from '@inertiajs/vue3';
import SiteHeader from "@/components/SiteHeader.vue";
import SiteFooter from "@/components/SiteFooter.vue";

import { useI18n } from 'vue-i18n';
import { loadLocaleMessages } from '@/plugins/i18n';
const { locale, t, setLocaleMessage } = useI18n({ useScope: 'global' });

import { watch } from "vue";
import {usePage} from "@inertiajs/vue3";
const page = usePage()

watch(page, () => {
    locale.value = page.props.locale
    loadLocaleMessages({setLocaleMessage}, page.props.locale)
}, {immediate: true, deep: true})
</script>

<template>
    <div class="bg-white">
        <site-header />

        <slot />

        <site-footer />
    </div>
</template>
